import { useLocation } from "react-router-dom";
import { useFetchCoordsToPositionQuery } from "../../api/rtk/base/slices/mapApiSlice";
import { Skeleton } from "primereact/skeleton";
import { useFetchGeoAddressQuery } from "../../api/rtk/geocoder/slices/geocoderApiSlice";
import { getItemWebStorage } from "src/features/webStorageSaver";

export default function AddressInfo() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const longitude = parseFloat(searchParams.get('lon') || '');
    const latitude = parseFloat(searchParams.get('lat') || '');
    const currentConfig = getItemWebStorage("currentConfig");
    const isPositionShown = currentConfig?.objectsList?.isPositionShown

    const { data: position, isFetching: isFetchingPosition } = useFetchCoordsToPositionQuery({ latitude, longitude }, { skip: !isPositionShown })
    const { data: address, isFetching: isFetchingAddress } = useFetchGeoAddressQuery({ latitude, longitude })
    const { ProjectPosition, MaintenancePosition, RoadName, PathName } = position ?? {}

    return (
        <div className="address-info-div">
            {isPositionShown &&
                <>
                    <p className="project-position">
                        <strong>Км:</strong>
                        {isFetchingPosition ? <Skeleton /> : <span> {ProjectPosition ?? 'не указано'}</span>}
                    </p>
                    <p className="maintenance-position">
                        <strong>Км+:</strong>
                        {isFetchingPosition ? <Skeleton /> : <span> {MaintenancePosition ?? 'не указано'}</span>}
                    </p>
                    <br />
                    <p className="road-name">
                        <strong>По дороге:</strong>
                        {isFetchingPosition ? <Skeleton /> : <span> {RoadName ?? 'не указано'}</span>}
                    </p>
                    <p className="path-name">
                        <strong>По направлению:</strong>
                        {isFetchingPosition ? <Skeleton /> : <span> {PathName ?? 'не указано'}</span>}
                    </p>
                    <br />
                </>
            }
            <p className="address">
                <strong>Адрес:</strong>
                {isFetchingAddress ? <Skeleton /> : <span> {address ?? 'не указано'}</span>}
            </p>
        </div>
    )
}
